import {
    Directive,
    ElementRef,
    Input,
    OnInit,
    Renderer2
  } from '@angular/core';
  import { NgControl } from '@angular/forms';
  
  @Directive({
    selector: '[customRangeSlider]'
  })
  export class CustomRangeSliderDirective implements OnInit {
    @Input() rangeValues: number[] = [];
    private sliderInput!: HTMLInputElement;
  
    constructor(
      private el: ElementRef,
      private renderer: Renderer2,
      private control: NgControl
    ) {}
  
    ngOnInit(): void {
      if (!this.rangeValues || this.rangeValues.length === 0) {
        console.warn('customRangeSlider: No range values provided.');
        return;
      }
  
      this.createSlider();
    }
  
    private createSlider() {
      const parent = this.renderer.parentNode(this.el.nativeElement);
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
  
      this.sliderInput = this.renderer.createElement('input');
      this.renderer.setAttribute(this.sliderInput, 'type', 'range');
      this.renderer.setAttribute(this.sliderInput, 'min', '0');
      this.renderer.setAttribute(this.sliderInput, 'max', (this.rangeValues.length - 1).toString());
      this.renderer.setAttribute(this.sliderInput, 'value', '0');
      this.renderer.addClass(this.sliderInput, 'slider');
  
      this.renderer.appendChild(parent, this.sliderInput);
  
      // Set initial value
      this.control.control?.setValue(this.rangeValues[0]);
  
      this.renderer.listen(this.sliderInput, 'input', (event: Event) => {
        const position = +(event.target as HTMLInputElement).value;
        const newValue = this.rangeValues[position];
        this.control.control?.setValue(newValue);
      });
  
      // Listen for external changes to form control
      this.control.control?.valueChanges.subscribe((val) => {
        const index = this.rangeValues.indexOf(val);
        if (index !== -1 && index !== +this.sliderInput.value) {
          this.sliderInput.value = index.toString();
        }
      });
    }
  }
  